module.exports = __webpack_public_path__ + "img/ascending.d1b06e8e.svg";